import * as React from 'react';
import * as styles from './styles.css';
import { Button, ArticleHeading4 } from '@cian/ui-kit';
import { RoundedCounter } from '@cian/valuation-component';
import { useIsDesktop } from '@cian/valuation-utils-component';

interface IMoreFiltersBtnProps {
  onClick(): void;
  count?: number;
  buttonText: string;
}

export const MoreFiltersBtn: React.FC<IMoreFiltersBtnProps> = ({ onClick, count, buttonText }) => {
  const isDesktop = useIsDesktop();
  const theme = isDesktop ? 'fill_white_primary' : 'fill_secondary';

  return (
    <Button
      onClick={onClick}
      theme={theme}
      size="L"
      beforeIcon={
        <div className={styles['button-content']}>
          <span className={styles['button-content-title']}>
            <ArticleHeading4 color="text-main-default">{buttonText}</ArticleHeading4>
          </span>
          {count && <RoundedCounter count={count} />}
        </div>
      }
      fullWidth={!isDesktop}
      data-testid="precise_filters_more_btn"
    />
  );
};

MoreFiltersBtn.displayName = 'MoreFiltersBtn';
